import { Record } from "immutable";
import {
  SET_APP_DECIMAL,
  SET_APP_TITLE,
  SET_USERNAME,
  TOGGLE_DRAWER,
  SET_BANDED_ROWS,
  SET_GRID_VERTICAL_LINES,
  SET_GRID_FONT_SIZE,
  SET_GRID_ROW_HEIGHT,
  SET_HIDE_GRID_SIDE_BAR,
  SET_NO_ACCOUNT_FLAG,
  SET_DISPLAY_MAJOR_MINOR_ON_TITLE
} from "./actions";

const State = Record({
  drawerOpen: true,
  appTitle: "Trade History",
  username: null,
  appDecimal: 2,
  bandedRows: true,
  gridVerticalLines: true,
  gridFontSize: 12,
  gridRowHeight: 22,
  hideGridSideBar: false,
  noAccountLoad: false,
  displayMajorMinorOnTitle: true
});

export default (state = new State(), action) => {
  switch (action.type) {
    case TOGGLE_DRAWER:
      return state.set(
        "drawerOpen",
        action?.override ?? !state.get("drawerOpen")
      );
    case SET_APP_TITLE:
      return state.set("appTitle", action.appTitle);
    case SET_APP_DECIMAL:
      return state.set("appDecimal", action.appDecimal);
    case SET_USERNAME:
      return state.set("username", action.username);
    case SET_BANDED_ROWS:
      return state.set("bandedRows", action.bandedRows);
    case SET_GRID_VERTICAL_LINES:
      return state.set("gridVerticalLines", action.gridVerticalLines);
    case SET_GRID_FONT_SIZE:
      return state.set("gridFontSize", action.gridFontSize);
    case SET_GRID_ROW_HEIGHT:
      return state.set("gridRowHeight", action.gridRowHeight);
    case SET_HIDE_GRID_SIDE_BAR:
      return state.set("hideGridSideBar", action.value);
    case SET_NO_ACCOUNT_FLAG:
      return state.set("noAccountLoad", action.noAccountLoad);
    case SET_DISPLAY_MAJOR_MINOR_ON_TITLE:
      return state.set("displayMajorMinorOnTitle", action.displayMajorMinotOnTitle);
    default:
      return state;
  }
};
